import { usePage } from "@/lib/content";
import { Reveal } from "@/components/site/Motion";
import { PageHero, SectionHead, CTABand, usePageTitle } from "@/components/site/Bits";
import { splitParagraphs } from "@/lib/content";

const BLOCKS = [
  { key: "identidade", num: "01" },
  { key: "proposta", num: "02" },
  { key: "abordagem", num: "03" },
  { key: "compromisso", num: "04" },
];

export default function QuemSomos() {
  usePageTitle("Quem Somos");
  const { sections: s } = usePage("quem_somos");

  return (
    <>
      <PageHero title={s.hero_title || "Quem Somos"} text={s.hero_text} overline="Silva Cotan e Associados — Assessoria Jurídica" />

      <section className="bg-ivory">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
          <div className="grid gap-10 md:grid-cols-2">
            {BLOCKS.map((b, i) => (
              <Reveal key={b.key} delay={0.06 * i}>
                <div className="h-full border border-navy/10 bg-white p-9 transition-colors duration-300 hover:border-gold md:p-11" data-testid={`quem-somos-block-${b.key}`}>
                  <span className="font-display text-sm italic text-gold">{b.num}</span>
                  <h2 className="mt-4 font-display text-2xl text-navy md:text-3xl">{s[`${b.key}_title`]}</h2>
                  <div className="gold-rule my-5 w-14" aria-hidden="true" />
                  {splitParagraphs(s[`${b.key}_text`]).map((p, j) => (
                    <p key={j} className="mb-4 text-sm leading-relaxed text-inkgray last:mb-0 md:text-[15px]">{p}</p>
                  ))}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-navy text-ivory grain">
        <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 py-20 md:px-8 md:py-28 lg:grid-cols-12">
          <div className="relative lg:col-span-5">
            <Reveal>
              <div className="absolute -inset-3 rounded-t-[200px] border border-gold/25 md:-inset-4" aria-hidden="true" />
              <div className="relative overflow-hidden rounded-t-[200px] border border-gold/40 bg-navy-2" data-testid="quem-somos-photo-frame">
                <img
                  src={s.advogada_image || "/media/dra-em-pe.jpg"}
                  alt="Dra. Fernanda Cotan, advogada responsável pela Silva Cotan"
                  className="aspect-[4/5] w-full object-cover object-top"
                  data-testid="quem-somos-photo"
                />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <SectionHead light num="05" title={s.advogada_title || "Dra. Fernanda Cotan"} />
            <Reveal delay={0.2}>
              {splitParagraphs(s.advogada_text).map((p, j) => (
                <p key={j} className="mt-5 max-w-2xl text-base leading-relaxed text-ivory/70">{p}</p>
              ))}
            </Reveal>
            <Reveal delay={0.3}>
              <p className="mt-10 max-w-xl border-l-2 border-gold pl-6 font-display text-xl italic leading-relaxed text-ivory/85 md:text-2xl">
                “Justiça é o equilíbrio entre direitos e deveres.”
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <CTABand title="Converse com a Silva Cotan sobre a sua demanda." button="Entrar em contato" />
    </>
  );
}
